import { ICommandBarItemProps, registerIcons } from '@fluentui/react';
import { GitHubLogoIcon } from '@fluentui/react-icons-mdl2';

registerIcons({
  icons: {
    GitHubLogoIcon: <GitHubLogoIcon />,
  },
});

export const usePowerShellButtonItemProps = (): ICommandBarItemProps => {
  return {
    key: 'powerShellButton',
    text: 'PowerShell',
    iconProps: { iconName: 'GitHubLogoIcon' },
    href: 'https://github.com/microsoft/MSRC-Microsoft-Security-Updates-API',
    target: '_blank',
  };
};
